"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var react_inlinesvg_1 = __importDefault(require("react-inlinesvg"));
var classnames_1 = __importDefault(require("classnames"));
var icon_info_svg_1 = __importDefault(require("../../src/images/ui-kit/icon-info.svg"));
require("./CJLogo.css");
var IconInfo = function (_a) {
    var className = _a.className, restProps = __rest(_a, ["className"]);
    return (react_1["default"].createElement(react_inlinesvg_1["default"], __assign({}, restProps, { src: icon_info_svg_1["default"], className: (0, classnames_1["default"])('vs-icon', className) })));
};
exports["default"] = IconInfo;
